import { render, staticRenderFns } from "./PanelGroup.vue?vue&type=template&id=633f7a5b&scoped=true&"
import script from "./PanelGroup.vue?vue&type=script&lang=js&"
export * from "./PanelGroup.vue?vue&type=script&lang=js&"
import style0 from "./PanelGroup.vue?vue&type=style&index=0&id=633f7a5b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "633f7a5b",
  null
  
)

export default component.exports